// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import i18n from './i18n'
import router from './router'
import VueRouter from 'vue-router';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/display.css';
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import 'vue2-animate/dist/vue2-animate.min.css'
import VModal from 'vue-js-modal'
import VueMeta from 'vue-meta'
import VueClipboard from 'vue-clipboard2'

import { DropdownPlugin } from 'bootstrap-vue'
Vue.use(DropdownPlugin)

import VueGtag from "vue-gtag";
// import 'lib-flexible/flexible'
import Vuex from 'vuex'
import store from "./store/";
import "./assets/icons/index"
import $ from 'jquery'
Vue.config.productionTip = false
Vue.use(Vuex);
Vue.use(VModal)
Vue.use(ElementUI);
Vue.use(VueAwesomeSwiper);
Vue.use(VueMeta);
Vue.use(VueClipboard)
/* eslint-disable no-new */

const originalPush = VueRouter.prototype.push
   VueRouter.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}

new Vue({
  i18n,
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js